module.exports = __webpack_public_path__ + "img/16.28e7d537.png";